/* ==========================================================================
   COLLECTION SLIDER – SINGLE CONTROLLER
   Safari viewport fix + slider logic + images priming
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
   * SAFARI REAL VIEWPORT FIX
   * -------------------------------------------------------------------------- */
  function setRealVh() {
    const vh = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;

    document.documentElement.style.setProperty('--real-vh', `${vh}px`);
  }

  setRealVh();
  window.addEventListener('resize', setRealVh);
  window.visualViewport?.addEventListener('resize', setRealVh);
  window.visualViewport?.addEventListener('scroll', setRealVh);

  /* --------------------------------------------------------------------------
   * DOM READY
   * -------------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    const panel = document.getElementById('collection-slider');
    if (!panel) return;

    if (!panel.dataset.openFlip) panel.dataset.openFlip = 'A';

    const stage  = panel.querySelector('#tab-stage');
    const tabsEl = panel.querySelector('.custom-collection-tabs');
    const groups = Array.from(panel.querySelectorAll('.custom-collection-group'));
    const back   = panel.querySelector('.custom-collection-back');

    const CLOSE_MS = 700;
    document.body.classList.remove('closing');

    /* ----------------------------------------------------------------------
     * STATE HELPERS
     * ---------------------------------------------------------------------- */
    function showStage() {
      groups.forEach(g => (g.hidden = true));
      if (stage) stage.hidden = false;
      tabsEl?.classList.remove('is-hidden');
      if (back) back.hidden = true;
      document.body.classList.remove('collection-in-group');
    }

    function showGroup(id) {
      const g = id ? panel.querySelector('#' + id) : null;
      if (!g) return showStage();

      groups.forEach(x => (x.hidden = x !== g));
      if (stage) stage.hidden = true;
      tabsEl?.classList.add('is-hidden');
      if (back) back.hidden = false;
      document.body.classList.add('collection-in-group');
    }

    /* ----------------------------------------------------------------------
     * CLICK DELEGATION (inside panel)
     * ---------------------------------------------------------------------- */
    panel.addEventListener('click', e => {
      const tabBtn = e.target.closest('.custom-collection-tab');
      if (tabBtn) {
        e.preventDefault();
        showGroup(tabBtn.dataset.target);
        return;
      }

      if (e.target.closest('.custom-collection-back')) {
        e.preventDefault();
        showStage();
        return;
      }

      if (e.target.closest('.custom-collection-close')) {
        document.body.classList.add('closing');
        setTimeout(() => document.body.classList.remove('closing'), CLOSE_MS);
      }
    });

    /* ----------------------------------------------------------------------
     * OPEN FROM HEADER / EXTERNAL BUTTON
     * ---------------------------------------------------------------------- */
    document.addEventListener(
      'click',
      e => {
        const opener = e.target.closest('.js-open-collection-slider, #open-slider-btn');
        if (!opener) return;

        setTimeout(showStage, 0);
      },
      true
    );

    /* ----------------------------------------------------------------------
     * PANEL VISIBILITY OBSERVER
     * ---------------------------------------------------------------------- */
    const panelObserver = new MutationObserver(() => {
      const hidden =
        panel.hasAttribute('hidden') ||
        panel.getAttribute('aria-hidden') === 'true';

      if (!hidden) showStage();
    });

    panelObserver.observe(panel, {
      attributes: true,
      attributeFilter: ['hidden', 'aria-hidden', 'style', 'class']
    });

    /* ----------------------------------------------------------------------
     * IMAGE PRIMING (tabs)
     * ---------------------------------------------------------------------- */
    let imagesPrimed = false;

    function primeTabImages() {
      if (imagesPrimed) return;
      imagesPrimed = true;

      panel
        .querySelectorAll('.custom-collection-tabs .tabimg')
        .forEach(img => {
          try {
            img.loading = 'eager';
            img.fetchPriority = 'high';
          } catch (_) {}
          if (!img.complete) img.decode?.().catch(() => {});
        });
    }

    primeTabImages();

    document.addEventListener(
      'pointerdown',
      e => {
        if (e.target.closest('.js-open-collection-slider, #open-slider-btn')) {
          primeTabImages();
        }
      },
      { capture: true, passive: true }
    );

    /* ----------------------------------------------------------------------
     * OPEN ANIMATION RESET (NO FLASH)
     * ---------------------------------------------------------------------- */
    document.addEventListener(
      'click',
      e => {
        const opener = e.target.closest('.js-open-collection-slider, #open-slider-btn');
        if (!opener) return;

        if (
          document.body.classList.contains('slider-active') ||
          document.body.classList.contains('closing')
        ) {
          return;
        }

        if (panel.__resetDoneForOpen) return;
        panel.__resetDoneForOpen = true;

        panel.dataset.openFlip = panel.dataset.openFlip === 'A' ? 'B' : 'A';

        const cont = panel.querySelector('.custom-collection-container');
        if (!cont) return;

        cont.style.animation = 'none';
        void cont.offsetHeight;
        requestAnimationFrame(() => (cont.style.animation = ''));
      },
      true
    );

    function clearResetFlag() {
      if (!document.body.classList.contains('slider-active')) {
        panel.__resetDoneForOpen = false;
      }
    }

    document.addEventListener('transitionend', clearResetFlag, true);
    document.addEventListener('animationend', clearResetFlag, true);

    /* INIT */
    showStage();
  });
})();
